import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { BASE_API, USER_TOKEN } from 'config/consts';

const URL = `${BASE_API}/guests`;

const authHeaders = () => ({
  headers: {
    Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
  },
});

export const listMyGuests =
  (page = 1, limit = 20) =>
  (dispatch) => {
    dispatch({ type: 'GUESTS_LOAD', payload: true });
    axios
      .get(`${URL}?page=${page}&limit=${limit}`, authHeaders())
      .then((response) => {
        dispatch({ type: 'GUESTS_FETCHED', payload: response.data });
      })
      .catch((e) => {
        const code = e?.response?.data?.code;
        if (code === 'guest_feature_disabled') {
          dispatch({ type: 'GUESTS_FEATURE_DISABLED' });
          return;
        }
        dispatch({ type: 'GUESTS_LOAD', payload: false });
        toastr.error(
          'Erro',
          'Não foi possível carregar a lista de convidados.'
        );
      });
  };

export const createGuest =
  (payload, callbacks = {}) =>
  (dispatch) => {
    const { onSuccess, onError } = callbacks;
    dispatch({ type: 'GUESTS_INVITE_LOAD', payload: true });
    dispatch({ type: 'GUESTS_INVITE_ERROR', payload: null });
    axios
      .post(URL, payload, authHeaders())
      .then(() => {
        dispatch({ type: 'GUESTS_INVITE_LOAD', payload: false });
        toastr.success(
          'Convite enviado',
          'O convidado receberá o link por e-mail e WhatsApp.'
        );
        dispatch(listMyGuests());
        if (onSuccess) onSuccess();
      })
      .catch((e) => {
        const error = e?.response?.data || {
          code: 'unknown',
          error: 'Não foi possível enviar o convite.',
        };
        dispatch({ type: 'GUESTS_INVITE_LOAD', payload: false });
        dispatch({ type: 'GUESTS_INVITE_ERROR', payload: error });
        if (onError) onError(error);
      });
  };

export const revokeGuest =
  (id, callbacks = {}) =>
  (dispatch) => {
    const { onSuccess, onError } = callbacks;
    dispatch({ type: 'GUESTS_REVOKE_LOAD', payload: true });
    axios
      .delete(`${URL}/${id}`, authHeaders())
      .then(() => {
        dispatch({ type: 'GUESTS_REVOKE_LOAD', payload: false });
        toastr.success('Convidado removido', 'O acesso foi revogado.');
        dispatch(listMyGuests());
        if (onSuccess) onSuccess();
      })
      .catch((e) => {
        dispatch({ type: 'GUESTS_REVOKE_LOAD', payload: false });
        const code = e?.response?.data?.code;
        if (code !== 'guest_feature_disabled') {
          const msg =
            e?.response?.data?.error || 'Não foi possível excluir o convidado.';
          toastr.error('Erro', msg);
        }
        if (onError) onError(e?.response?.data || {});
      });
  };

export const clearInviteError = () => ({
  type: 'GUESTS_INVITE_ERROR',
  payload: null,
});

export const fetchEligibleDependents = () => (dispatch) => {
  dispatch({ type: 'GUESTS_DEPENDENTS_LOAD', payload: true });
  axios
    .get(`${URL}/eligible-dependents`, authHeaders())
    .then((response) => {
      dispatch({
        type: 'GUESTS_DEPENDENTS_FETCHED',
        payload: response.data.items || [],
      });
    })
    .catch((e) => {
      const error = e?.response?.data || {
        code: 'unknown',
        error: 'Não foi possível carregar a lista de dependentes.',
      };
      dispatch({ type: 'GUESTS_DEPENDENTS_ERROR', payload: error });
      if (error.code !== 'guest_feature_disabled') {
        toastr.error('Erro', error.error);
      }
    });
};

export const validateInviteToken = (token, channel) => (dispatch) => {
  dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: true });
  const channelQuery = channel ? `?c=${encodeURIComponent(channel)}` : '';
  axios
    .get(
      `${BASE_API}/guests/invite/${encodeURIComponent(token)}${channelQuery}`
    )
    .then((response) => {
      dispatch({ type: 'GUESTS_ACCEPT_META', payload: response.data });
      dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: false });
    })
    .catch((e) => {
      const error = e?.response?.data || {
        code: 'invalid_token',
        error: 'Convite inválido ou expirado.',
      };
      dispatch({ type: 'GUESTS_ACCEPT_ERROR', payload: error });
      dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: false });
    });
};

export const acceptInvite =
  (token, password, passwordConfirmation, history) => (dispatch) => {
    dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: true });
    axios
      .post(`${BASE_API}/guests/accept`, {
        token,
        password,
        password_confirmation: passwordConfirmation,
      })
      .then((response) => {
        const user = response.data.user;
        if (user && user.station && user.station.establishment) {
          user.establishment_participant = user.station.establishment;
        }
        const loginPayload = {
          data: { content: user, token: response.data.token },
        };
        dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: false });
        toastr.success(
          'Cadastro concluído',
          `Bem-vindo(a) ao Sindilegis+, ${user.name}!`
        );
        dispatch({ type: 'USER_FETCHED', payload: loginPayload });
        if (history) history.push(user.briefingDone ? '/' : '/signup');
      })
      .catch((e) => {
        const error = e?.response?.data || {
          code: 'unknown',
          error: 'Não foi possível concluir o cadastro.',
        };
        dispatch({ type: 'GUESTS_ACCEPT_ERROR', payload: error });
        dispatch({ type: 'GUESTS_ACCEPT_LOAD', payload: false });
      });
  };

export const resetAcceptState = () => ({ type: 'GUESTS_ACCEPT_RESET' });
